module.exports = __webpack_public_path__ + "static/media/bingo-cards.cf019235.png";